export default {
  title: "Facturen zoeken",

  input: {
    status: "Status",
    invoiceNumber: "Factuurnummer",
    target: "Naam",
    type: "Type",
  },
}
